var map = {
	"./Association France Palestine.png": 657,
	"./Clermont Folk.png": 248,
	"./Clermont-Ferrand logo à jour.png": 782,
	"./Crous.png": 890,
	"./Les Brayauds-CDMDT 63(1).png": 457,
	"./UCA.png": 329,
	"./cropped-logo-LieU-nouveau-orange-bleu-2.png": 742,
	"./logo_cvec.png": 279
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21;